import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsIbmComponent } from './simple-icons-ibm.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsIbmComponent ],
    exports:      [ SimpleIconsIbmComponent ],
    bootstrap:    []
})
export class SimpleIconsIbmModule {}
